<template>
  <div class="image">
    <div class="img-pic" @click="onClick">
      <img :src="url" />
    </div>
    <a-modal
      v-model:visible="visible"
      title="预览"
      width="888px"
      :footer="null"
      @ok="onOk">
      <img :src="url" class="modal-pic" />
    </a-modal>
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue'

export default defineComponent({
  name: 'Image',
  components: {
  },
  props: {
    url: String
  },
  emit: [],
  setup (props, { emit }) {
    const visible = ref(false)

    const onClick = () => {
      visible.value = true
    }

    const handleOk = () => {
      visible.value = false
    }

    return {
      visible,
      onClick,
      handleOk
    }
  }
})
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.image {
  .img-pic {
    img {
      width: 100px;
    }
  }
}
.modal-pic {
  width: 100%;
}
</style>
